import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center items-center py-12"
};
const _hoisted_2 = {
    key: 1,
    class: "flex flex-col items-center gap-4 py-12 text-center"
};
const _hoisted_3 = { class: "text-sm text-(--text-text-black-default)" };
const _hoisted_4 = {
    key: 2,
    class: "flex flex-col gap-4"
};
const _hoisted_5 = { class: "flex flex-col gap-1" };
const _hoisted_6 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_7 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_8 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_9 = {
    key: 0,
    class: "flex flex-col gap-1"
};
const _hoisted_10 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_11 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_12 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_13 = {
    key: 1,
    class: "flex flex-col gap-1"
};
const _hoisted_14 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_15 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_16 = {
    key: 2,
    class: "flex flex-col gap-1"
};
const _hoisted_17 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_18 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_19 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_20 = {
    key: 3,
    class: "flex flex-col gap-1"
};
const _hoisted_21 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_22 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_23 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_24 = { class: "flex flex-col gap-1" };
const _hoisted_25 = { class: "text-sm font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_26 = { class: "flex items-center gap-2 px-3 py-2 rounded-xl border border-(--border-border-base-soft) bg-(--background-background-white-secondary-soft)" };
const _hoisted_27 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { Drawer, PhoneDisplay } from '@eudonet/opal';
import { useProfileStore } from '@/modules/settings/public';
import { formatDate } from '@/shared/utils/date-formatting';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactPreviewDrawer',
    props: {
        modelValue: { type: Boolean },
        contact: {},
        loading: { type: Boolean },
        error: {},
        fallbackTitle: {}
    },
    emits: ["update:modelValue", "go-to", "retry"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { locale, t } = useI18n();
        const profileStore = useProfileStore();
        const fullName = computed(() => props.contact ? `${props.contact.firstName} ${props.contact.lastName}` : '');
        const categoryBadges = computed(() => props.contact?.category
            ? [
                {
                    label: t(`contact.create.fields.category.options.${props.contact.category.toLowerCase()}`),
                    theme: 'red',
                    showLeftIcon: false,
                    showCloseIcon: false,
                },
            ]
            : undefined);
        const footerActions = computed(() => [
            { id: 'view-record', label: t('contact.create.preview.viewRecord'), onClick: () => emit('go-to') },
        ]);
        const addressText = computed(() => {
            const a = props.contact?.address;
            if (!a)
                return '';
            return [a.addressLine, a.postalCode, a.city, a.country].filter(Boolean).join(', ');
        });
        const formattedCreatedAt = computed(() => props.contact
            ? formatDate(props.contact.createdAt, locale.value, profileStore.profile?.dateFormat)
            : '');
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Drawer), {
                "model-value": __props.modelValue,
                position: "right",
                size: "md",
                title: __props.contact ? fullName.value : __props.fallbackTitle,
                avatar: __props.contact ? { name: fullName.value, img: __props.contact.avatarUrl ?? undefined, entity: 'contact' } : undefined,
                badges: categoryBadges.value,
                "aria-label": __props.contact || __props.fallbackTitle ? undefined : _ctx.$t('contact.create.dedup.preview'),
                actions: footerActions.value,
                "aria-close-label": _ctx.$t('common.close'),
                "show-close-button": true,
                "close-on-escape": true,
                dismissable: true,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('update:modelValue', $event)))
            }, {
                default: _withCtx(() => [
                    (__props.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "ri-loader-4-line animate-spin text-2xl text-(--text-text-body-subtle)" }, null, -1 /* CACHED */)
                            ]))]))
                        : (__props.error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "ri-error-warning-line text-3xl text-(--colors-icon-error)" }, null, -1 /* CACHED */)),
                                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('contact.create.preview.error')), 1 /* TEXT */),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "text-sm font-medium text-(--text-text-link) hover:text-(--text-text-hover) transition-colors",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('retry')))
                                }, _toDisplayString(_ctx.$t('contact.create.preview.retry')), 1 /* TEXT */)
                            ]))
                            : (__props.contact)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('contact.create.fields.contactType')), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(`contact.create.contactType.${__props.contact.type === 'Professional' ? 'professional' : 'individual'}`)), 1 /* TEXT */)
                                        ])
                                    ]),
                                    (__props.contact.email)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('contact.create.preview.email')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_11, [
                                                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "ri-mail-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(__props.contact.email), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.contact.mainPhone)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                            _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('contact.create.preview.phone')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_15, [
                                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "ri-phone-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createVNode(_unref(PhoneDisplay), {
                                                    value: __props.contact.mainPhone,
                                                    link: false,
                                                    class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)"
                                                }, null, 8 /* PROPS */, ["value"])
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (__props.contact.organisationLabel)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('contact.create.preview.organisation')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_18, [
                                                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "ri-building-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_19, _toDisplayString(__props.contact.organisationLabel), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    (addressText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                            _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('contact.create.preview.address')), 1 /* TEXT */),
                                            _createElementVNode("div", _hoisted_22, [
                                                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "ri-map-pin-2-line text-sm text-(--text-text-body-subtle) shrink-0" }, null, -1 /* CACHED */)),
                                                _createElementVNode("span", _hoisted_23, _toDisplayString(addressText.value), 1 /* TEXT */)
                                            ])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('contact.create.preview.createdAt')), 1 /* TEXT */),
                                        _createElementVNode("div", _hoisted_26, [
                                            _createElementVNode("span", _hoisted_27, _toDisplayString(formattedCreatedAt.value), 1 /* TEXT */)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["model-value", "title", "avatar", "badges", "aria-label", "actions", "aria-close-label"]));
        };
    }
});
